import { isAdmin, isCustomerAdmin } from "./helpers";
const accountingPermissions = {
    accounting: {
        index: ({ user, customer }) => isCustomerAdmin(user, customer),
        costs: ({ user, customer }) => isCustomerAdmin(user, customer),
        createCheckoutSession: ({ user, customer }) => isCustomerAdmin(user, customer),
        createAdjustment: ({ user }) => isAdmin(user),
    },
};
export default accountingPermissions;
